// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import translate from "@insite/client-framework/Translate";
import { getShippingInformation } from "@tps/App/Services/CartService";
import { ErrorApiDefaultMessage } from "@tps/XDL/constants";

type HandlerType = Handler<
    { warehouseId: string; onError?: (error: string) => void },
    {
        apiResult: any;
    }
>;

export const DispatchBeginLoadCartShippingInformation: HandlerType = props => {
    props.dispatch({
        type: "xShippingDetails/BeginLoadShippingDetails",
    } as any);
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getShippingInformation({ warehouseId: props.parameter.warehouseId });
    } catch (error) {
        props.dispatch({
            type: "xShippingDetails/ResetIsLoadingShippingDetails",
            isLoading: false,
        } as any);
        const failedMessage = error.errorMessage || translate(ErrorApiDefaultMessage);
        props.parameter.onError?.(failedMessage);
        return false;
    }
};

export const DispatchCompleteLoadCartShippingInformation: HandlerType = props => {
    if (props.apiResult && props.apiResult.length > 0) {
        props.dispatch({
            type: "xShippingDetails/CompleteLoadShippingDetails",
            shippingInfo: props.apiResult[0],
            warehouseId: props.apiResult[0].warehouseId,
        } as any);
    } else {
        props.dispatch({
            type: "xShippingDetails/ResetIsLoadingShippingDetails",
            isLoading: false,
        } as any);
    }
};

export const chain = [
    DispatchBeginLoadCartShippingInformation,
    RequestDataFromApi,
    DispatchCompleteLoadCartShippingInformation,
];

const loadCartShippingInformation = createHandlerChainRunner(chain, "loadCartShippingInformation");

export default loadCartShippingInformation;
